import React from 'react';
import { Reveal } from './Reveal';
export function MaterialsSection() {
  return <section className="w-full sm:pb-24 bg-[#F5EFE8] pb-[27px]" data-id="element-234" data-mp="r87l77su9p5f">
      <div className="mx-auto flex w-full max-w-5xl flex-col items-center px-5 sm:px-8 pl-[5px]" data-id="element-235" data-mp="r8hep5d3eefv">
        
        {/* Sin gastar de más Box */}
        <Reveal className="w-full" data-id="element-236" data-mp="116wwghq8cbcp">
          <div className="relative mt-8 rounded-[24px] border-[1.5px] border-[#F27B35]/80 bg-gradient-to-br from-[#FFFDF9] to-[#FFF0E0] p-5 shadow-sm sm:p-8 sm:pt-12 pt-[21px] pb-[4px] pl-[6px] pr-[8px] w-[368px] h-[253px]" data-id="element-237" data-mp="117yjzlofmqbb">
            
            {/* Decorative Diamonds */}
            <div className="absolute -left-2.5 -top-2.5 h-5 w-5 rotate-45 rounded-[3px] bg-[#FFD147]" aria-hidden="true" data-id="element-238" data-mp="1eytka9kv7z3a" />
            <div className="absolute -bottom-2.5 -right-2.5 h-5 w-5 rotate-45 rounded-[3px] bg-[#FFD147]" aria-hidden="true" data-id="element-239" data-mp="1jwdbea2nw6cn" />

            {/* Top Badge */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 rounded-full bg-[#1C3587] px-5 py-1.5 font-display text-[11px] font-black uppercase tracking-widest text-white shadow-md whitespace-nowrap" data-id="element-240" data-mp="1tuj9eglcksc8">
              ¡SIN GASTAR DE MÁS!
            </div>
            
            <div className="flex flex-row items-start gap-4 sm:gap-6" data-id="element-241" data-mp="zeub2d75512j">
              {/* Icon */}
              <div className="flex-none" data-id="element-242" data-mp="vd8qe5od7ihs">
                <span className="flex rounded-[18px] bg-white text-[32px] shadow-[0_8px_24px_rgba(242,123,53,0.15)] w-[51px] h-[42px] items-center justify-center" data-id="element-243" data-mp="vead57eqttfc">
                  📦
                </span>
              </div>
              
              {/* Text Content */}
              <div className="flex-1 text-left" data-id="element-244" data-mp="1id6km01yscyn">
                <h2 className="font-display text-[10px] font-black uppercase tracking-[0.15em] text-[#1C3587]" data-id="element-245" data-mp="1ibvj66vzrhap">
                  EMPEZÁ HOY MISMO
                </h2>
                
                <h3 className="mt-1.5 font-display text-[22px] font-black leading-[1.1] text-[#F27B35] sm:text-3xl w-[249px]" data-id="element-246" data-mp="2ausn8pxm837z">
                  Convertí materiales reciclados en increíbles inventos.
                </h3>
                
                <p className="mt-2.5 text-[14px] font-bold leading-snug text-[#4A5568] sm:text-base w-[250px] h-[55px]" data-id="element-247" data-mp="4837yivt7u7v">
                  Cajas, cartón, botellas, tapitas y tubos se transforman en proyectos creativos para aprender jugando.
                </p>
              </div>
            </div>

            {/* Materials Badges */}
            <div className="mt-6 flex w-full justify-between gap-2" data-id="element-248" data-mp="3hkdk0czo6mc1">
              <div className="flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-100 bg-[#F8FAFC] py-2.5 shadow-sm h-[39px]" data-id="element-249" data-mp="3mjq8f266w1gq">
                <span aria-hidden="true" className="text-sm" data-id="element-250" data-mp="37o0gyoi8iw4m">📦</span>
                <span className="font-display text-[11px] font-black text-[#1C3587]" data-id="element-251" data-mp="3ckqw99m7tnoz">Cajas</span>
              </div>
              <div className="flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-100 bg-[#F0FDF4] py-2.5 shadow-sm" data-id="element-252" data-mp="15w5hr8d60k3a">
                <span aria-hidden="true" className="text-sm" data-id="element-253" data-mp="1art8hs7aplaw">🧴</span>
                <span className="font-display text-[11px] font-black text-[#1C3587]" data-id="element-254" data-mp="2vcrb5csvamnq">Botellas</span>
              </div>
              <div className="flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-100 bg-[#FFFBEB] py-2.5 shadow-sm" data-id="element-255" data-mp="2qb21o1lamh1r">
                <span aria-hidden="true" className="text-sm" data-id="element-256" data-mp="30b18nu22dzci">📄</span>
                <span className="font-display text-[11px] font-black text-[#1C3587]" data-id="element-257" data-mp="3e2pkrxcbcnth">Tubos</span>
              </div>
              <div className="flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-100 bg-[#EFF6FF] py-2.5 shadow-sm" data-id="element-258" data-mp="3a1dzu54dwqrm">
                <span aria-hidden="true" className="text-sm" data-id="element-259" data-mp="3o0dgoqlno1d8">🔵</span>
                <span className="font-display text-[11px] font-black text-[#1C3587]" data-id="element-260" data-mp="3j1iztu790mvr">Tapitas</span>
              </div>
            </div>
          </div>
        </Reveal>

        {/* 4 Quick Benefits */}
        <Reveal className="mt-4 w-full" delay={0.2} data-id="element-261" data-mp="1ookt1kkrc8d6">
          <div className="grid grid-cols-4 gap-1.5 sm:gap-4" data-id="element-262" data-mp="1oq47d5mus9cb">
            
            <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-gray-100 bg-white p-2 text-center shadow-sm sm:p-4" data-id="element-263" data-mp="1q4f4p0uzaz59">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F1F5FB] text-lg sm:h-12 sm:w-12 sm:text-2xl" aria-hidden="true" data-id="element-264" data-mp="202l49btbbt6y">
                📹
              </span>
              <div data-id="element-265" data-mp="17eyxxvspaage">
                <h4 className="font-display text-[9px] font-black leading-tight text-[#1C3587] sm:text-[12px]" data-id="element-266" data-mp="17fi5cikq5gg6">
                  Videos fáciles
                </h4>
                <p className="mt-0.5 text-[7px] font-bold leading-tight text-gray-500 sm:text-[9px]" data-id="element-267" data-mp="1hcwmylidwba2">
                  Explicados paso a paso
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-gray-100 bg-white p-2 text-center shadow-sm sm:p-4" data-id="element-268" data-mp="oo7ge6yk7dqx">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F1F5FB] text-lg sm:h-12 sm:w-12 sm:text-2xl" aria-hidden="true" data-id="element-269" data-mp="tl7osoivssl7">
                🧩
              </span>
              <div data-id="element-270" data-mp="32w8hh0uiftuf">
                <h4 className="font-display text-[9px] font-black leading-tight text-[#1C3587] sm:text-[12px]" data-id="element-271" data-mp="32tvyckd0ndfs">
                  Proyectos creativos
                </h4>
                <p className="mt-0.5 text-[7px] font-bold leading-tight text-gray-500 sm:text-[9px]" data-id="element-272" data-mp="2sx1104shbj33">
                  Para aprender jugando
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-gray-100 bg-white p-2 text-center shadow-sm sm:p-4" data-id="element-273" data-mp="2j66fj2n24nip">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F1F5FB] text-lg sm:h-12 sm:w-12 sm:text-2xl" aria-hidden="true" data-id="element-274" data-mp="2a7kzpf8yzmlm">
                📄
              </span>
              <div data-id="element-275" data-mp="20954b02wtr6b">
                <h4 className="font-display text-[9px] font-black leading-tight text-[#1C3587] sm:text-[12px]" data-id="element-276" data-mp="209wrpnmcsili">
                  Material descargable
                </h4>
                <p className="mt-0.5 text-[7px] font-bold leading-tight text-gray-500 sm:text-[9px]" data-id="element-277" data-mp="1vk2soa7xqfw1">
                  Listo para usar
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-gray-100 bg-white p-2 text-center shadow-sm sm:p-4" data-id="element-278" data-mp="1lm6k9q6dtz1m">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F1F5FB] text-lg sm:h-12 sm:w-12 sm:text-2xl" aria-hidden="true" data-id="element-279" data-mp="29cajzmgg9enc">
                🎁
              </span>
              <div data-id="element-280" data-mp="20ixjnzg23ar8">
                <h4 className="font-display text-[9px] font-black leading-tight text-[#1C3587] sm:text-[12px]" data-id="element-281" data-mp="20hcny6i09lrs">
                  Bonos incluidos
                </h4>
                <p className="mt-0.5 text-[7px] font-bold leading-tight text-gray-500 sm:text-[9px]" data-id="element-282" data-mp="2s9tm064hpx09">
                  Sin costo adicional
                </p>
              </div>
            </div>

          </div>
        </Reveal>

      </div>
    </section>;
}